
export class GrnQtyRequest {
    purchaseOrderId: number;
    itemCategoryId: number;
    itemId: number;
    saleOrderId?: number;
}